import { useSyncExternalStore } from 'react';

export type DraftStatus = 'idle' | 'saving' | 'saved' | 'error';

let status: DraftStatus = 'idle';
const listeners = new Set<() => void>();

export function setDraftStatus(next: DraftStatus) {
  if (next === status) return;
  status = next;
  listeners.forEach((l) => l());
}

export function getDraftStatus(): DraftStatus {
  return status;
}

const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
};

export function useDraftStatus(): DraftStatus {
  return useSyncExternalStore(subscribe, getDraftStatus, getDraftStatus);
}
